module.exports = __webpack_public_path__ + "img/WakeUpSantaClausNew.1b2585b7.png";